document.addEventListener('DOMContentLoaded', () => {
	const heroImages = document.querySelectorAll(
		'section.hero .images:has(img:nth-child(2))'
	)

	heroImages.forEach(images => {
		setInterval(changeImg, 10000, images)
	})

	function changeImg(images) {
		var currIndex = parseInt(images.dataset.active)
		var total = parseInt(images.dataset.total)
		var targetIndex = currIndex + 1

		if (targetIndex > total) {
			targetIndex = 1
		}

		images.dataset.active = targetIndex
	}
})
